import { ReactComponent as CheckedIcon } from "assets/svgs/Checked.svg";

const Checkbox = ({
    description = "",
    descriptionClassName = "",
    size = "h-3 w-3",
    defaultChecked = undefined,
    onClick = () => {},
}) => {
    return (
        <div className="flex  items-center justify-between space-x-2">
            <div className="checkbox-wrapper relative flex items-center">
                <input
                    className={`group absolute cursor-pointer pl-3 opacity-0 ${size}`}
                    type="checkbox"
                    checked={defaultChecked}
                    onClick={onClick}
                />
                <div
                    className={`flex  items-center justify-center border-2 border-black40 bg-transparent ${size}`}
                >
                    <CheckedIcon
                        className={`group:block pointer-events-none hidden text-primary ${size}`}
                    />
                </div>
            </div>
            {description && (
                <p
                    className={`text-h5 cursor-default leading-none text-black20 ${descriptionClassName}`}
                >
                    {description}
                </p>
            )}
        </div>
    );
};

export default Checkbox;
